module.exports = __webpack_public_path__ + "static/media/Ecuador - EC.0cbe8fa8.png";